import Bold from './Bold';

export default Bold;
